var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subjects-page d-flex flex-column"
  }, [_c('h1', {
    staticClass: "page-title subjects-toolbar-layer"
  }, [_vm._v("Subjects")]), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex flex-wrap align-center subjects-toolbar subjects-toolbar-layer"
  }, [_c('v-btn', {
    staticClass: "subjects-toolbar__btn",
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.$router.push({
          name: 'SelectSession'
        });
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v(" Back to Sessions ")], 1), _c('v-btn', {
    staticClass: "subjects-toolbar__btn",
    attrs: {
      "color": "grey darken-4",
      "dark": ""
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.$refs.dialogRef.addSubject();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" New Subject ")], 1), _c('div', {
    staticClass: "show-removed-checkbox toolbar-checkbox"
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Show removed subjects",
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: _vm.show_trashed,
      callback: function ($$v) {
        _vm.show_trashed = $$v;
      },
      expression: "show_trashed"
    }
  })], 1), _c('div', {
    staticClass: "d-flex align-center flex-grow-1 flex-md-grow-0 ml-0 ml-md-auto mt-2 mt-md-0 subjects-search-section"
  }, [_c('div', {
    staticClass: "flex-grow-1 mr-2"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Subject ID/Name",
      "prepend-inner-icon": "mdi-magnify",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  })], 1), _vm.searchText ? _c('div', [_c('v-btn', {
    staticClass: "subjects-submit-btn",
    attrs: {
      "color": "grey darken-4",
      "dark": ""
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.onClearSearch();
      }
    }
  }, [_vm._v(" Clear ")])], 1) : _vm._e()])], 1)]), _c('v-row', {
    staticClass: "subjects-page-row",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "subjects-table-col",
    attrs: {
      "cols": "12",
      "md": _vm.selected ? 7 : 12
    }
  }, [_c('div', {
    staticClass: "subjects-table-wrapper"
  }, [_c('v-data-table', {
    staticClass: "subjects-table flex-grow-1",
    attrs: {
      "headers": _vm.displayHeaders,
      "items": _vm.valid_subjects,
      "options": _vm.options,
      "item-class": _vm.itemClasses,
      "loading": _vm.loading,
      "server-items-length": _vm.subject_total,
      "mobile-breakpoint": 0,
      "dense": _vm.$vuetify.breakpoint.smAndDown,
      "footer-props": {
        showFirstLastPage: false,
        disableItemsPerPage: true,
        itemsPerPageOptions: [40]
      },
      "height": _vm.tableHeightSubjects,
      "fixed-header": "",
      "single-select": ""
    },
    on: {
      "update:options": function ($event) {
        _vm.options = $event;
      },
      "item-selected": _vm.onSelect,
      "click:row": _vm.onRowClick
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function () {
        return [_c('div', {
          staticClass: "table-empty-state"
        }, [_c('v-icon', {
          staticClass: "mb-3",
          attrs: {
            "size": "48",
            "color": "grey"
          }
        }, [_vm._v(_vm._s(_vm.searchText.trim() ? 'mdi-magnify' : 'mdi-account-group-outline'))]), _c('p', {
          staticClass: "mb-0"
        }, [_vm._v(_vm._s(_vm.searchText.trim() ? 'No matching subjects' : 'No subjects yet'))]), _c('p', {
          staticClass: "text-caption mb-0 mt-1"
        }, [_vm._v(_vm._s(_vm.searchText.trim() ? 'Try a different search term or clear the search' : 'Create a new subject to get started'))])], 1)];
      },
      proxy: true
    }, {
      key: "item.name",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('div', {
          staticClass: "subject-name-cell"
        }, [_c('div', {
          staticClass: "subject-name-text cursor-pointer"
        }, [_vm._v(_vm._s(item.name))])])];
      }
    }, {
      key: "item.controls",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('div', {
          staticClass: "subject-actions-cell"
        }, [_vm.$vuetify.breakpoint.smAndDown ? [_c('v-btn', {
          attrs: {
            "icon": "",
            "dark": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openSubjectMenuSheet(item);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-menu")])], 1)] : _c('div', {
          staticClass: "subject-action-buttons"
        }, [!item.trashed ? _c('v-btn', {
          staticClass: "subject-action-btn",
          attrs: {
            "icon": "",
            "small": "",
            "dark": "",
            "title": "Edit subject"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.editSubject(item);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-pencil")])], 1) : _vm._e(), !item.trashed ? _c('v-btn', {
          staticClass: "subject-action-btn",
          attrs: {
            "icon": "",
            "small": "",
            "dark": "",
            "title": "Trash subject"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              _vm.selectedSubjectForTrash = item;
              _vm.remove_dialog = true;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-delete")])], 1) : _vm._e(), item.trashed ? _c('v-btn', {
          staticClass: "subject-action-btn",
          attrs: {
            "icon": "",
            "small": "",
            "dark": "",
            "title": "Restore subject"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              _vm.selectedSubjectForRestore = item;
              _vm.restore_dialog = true;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-restore")])], 1) : _vm._e(), item.trashed ? _c('v-btn', {
          staticClass: "subject-action-btn",
          attrs: {
            "icon": "",
            "small": "",
            "dark": "",
            "title": "Delete permanently"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              _vm.selectedSubjectForPermanentDelete = item;
              _vm.remove_permanently_dialog = true;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-delete-forever")])], 1) : _vm._e()], 1)], 2)];
      }
    }])
  })], 1)]), _vm.selected ? _c('v-col', {
    staticClass: "sessions-table-col",
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('div', {
    staticClass: "sessions-table-wrapper"
  }, [_vm.selected ? _c('v-data-table', {
    staticClass: "sessions-table flex-grow-1",
    attrs: {
      "headers": _vm.sessionDisplayHeaders,
      "items": _vm.valid_sessions,
      "options": _vm.session_options,
      "item-class": _vm.itemClasses,
      "loading": _vm.session_loading,
      "server-items-length": _vm.session_total,
      "mobile-breakpoint": 0,
      "dense": _vm.$vuetify.breakpoint.smAndDown,
      "footer-props": {
        showFirstLastPage: false,
        disableItemsPerPage: true,
        itemsPerPageOptions: [40]
      },
      "fixed-header": "",
      "height": _vm.tableHeightSessions,
      "single-select": ""
    },
    on: {
      "update:options": function ($event) {
        _vm.session_options = $event;
      },
      "click:row": _vm.onRowSessionClick
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function () {
        return [_c('div', {
          staticClass: "table-empty-state"
        }, [_c('v-icon', {
          staticClass: "mb-3",
          attrs: {
            "size": "48",
            "color": "grey"
          }
        }, [_vm._v("mdi-folder-outline")]), _c('p', {
          staticClass: "mb-0"
        }, [_vm._v("No sessions for this subject")])], 1)];
      },
      proxy: true
    }, {
      key: "item.sessionName",
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('div', {
          staticClass: "session-name-cell"
        }, [_c('div', {
          staticClass: "session-name-text"
        }, [_vm._v(_vm._s(item.sessionName || 'Untitled'))]), _vm.isPhone ? _c('div', {
          staticClass: "session-meta-row"
        }, [_c('span', {
          staticClass: "session-id-preview session-id-preview--mobile",
          attrs: {
            "title": item.id
          }
        }, [_vm._v(" " + _vm._s(_vm.getSessionIdPreview(item.id)) + " ")]), _c('span', {
          staticClass: "session-trials-preview"
        }, [_vm._v(_vm._s(item.trials_count || 0) + " trials")]), _c('v-btn', {
          staticClass: "copy-session-id-btn copy-session-id-btn--mobile",
          attrs: {
            "icon": "",
            "x-small": "",
            "dark": "",
            "title": "Copy session ID"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.copySessionId(item.id);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "x-small": ""
          }
        }, [_vm._v("mdi-content-copy")])], 1)], 1) : _vm._e()])];
      }
    }, {
      key: "item.id",
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('div', {
          staticClass: "session-id-cell",
          attrs: {
            "title": item.id
          }
        }, [_c('span', {
          staticClass: "session-id-preview"
        }, [_vm._v(_vm._s(_vm.getSessionIdPreview(item.id)))]), _c('v-btn', {
          staticClass: "copy-session-id-btn",
          attrs: {
            "icon": "",
            "small": "",
            "dark": "",
            "title": "Copy session ID"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.copySessionId(item.id);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-content-copy")])], 1)], 1)];
      }
    }, {
      key: "item.created_at",
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('span', [_vm._v(_vm._s(_vm._f("date")(item.created_at)))])];
      }
    }, {
      key: "item.controls",
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_c('div', {
          staticClass: "session-controls-cell"
        }, [_c('v-btn', {
          staticClass: "action-btn",
          attrs: {
            "icon": "",
            "small": "",
            "dark": "",
            "title": "Load session"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.loadSession(item);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-play")])], 1)], 1)];
      }
    }], null, false, 992083496)
  }) : _vm._e()], 1)]) : _vm._e()], 1), _c('v-bottom-sheet', {
    attrs: {
      "content-class": "bottom-sheet-rounded"
    },
    on: {
      "input": function (val) {
        return !val && (_vm.selectedSubjectForMenu = null);
      }
    },
    model: {
      value: _vm.showSubjectMenuSheet,
      callback: function ($$v) {
        _vm.showSubjectMenuSheet = $$v;
      },
      expression: "showSubjectMenuSheet"
    }
  }, [_c('v-sheet', {
    staticClass: "text-center subject-menu-sheet"
  }, [_vm.selectedSubjectForMenu ? _c('v-list', [!_vm.selectedSubjectForMenu.trashed ? _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndEdit(_vm.selectedSubjectForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-pencil")]), _c('span', [_vm._v("Edit")])], 1)])], 1) : _vm._e(), !_vm.selectedSubjectForMenu.trashed ? _c('v-divider') : _vm._e(), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.selectedSubjectForMenu.trashed,
      expression: "!selectedSubjectForMenu.trashed"
    }],
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndTrash(_vm.selectedSubjectForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-delete-outline")]), _c('span', [_vm._v("Trash")])], 1)])], 1), _vm.selectedSubjectForMenu.trashed ? _c('v-divider') : _vm._e(), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectedSubjectForMenu.trashed,
      expression: "selectedSubjectForMenu.trashed"
    }],
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndRestore(_vm.selectedSubjectForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-restore")]), _c('span', [_vm._v("Restore")])], 1)])], 1), _vm.selectedSubjectForMenu.trashed ? _c('v-divider') : _vm._e(), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectedSubjectForMenu.trashed,
      expression: "selectedSubjectForMenu.trashed"
    }],
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndPermanentDelete(_vm.selectedSubjectForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-delete-forever")]), _c('span', [_vm._v("Delete permanently")])], 1)])], 1), !_vm.selectedSubjectForMenu.trashed && _vm.isSyncDownloadAllowed ? _c('v-divider') : _vm._e(), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.selectedSubjectForMenu.trashed && _vm.isSyncDownloadAllowed,
      expression: "!selectedSubjectForMenu.trashed && isSyncDownloadAllowed"
    }],
    attrs: {
      "link": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeSheetAndDownload(_vm.selectedSubjectForMenu);
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "d-flex flex-row align-center justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-download")]), _c('span', [_vm._v("Download data (old)")])], 1)])], 1)], 1) : _vm._e()], 1)], 1), _c('v-dialog', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDialogSubjectHideMenu,
      expression: "clickOutsideDialogSubjectHideMenu"
    }],
    attrs: {
      "content-class": "confirm-dialog",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    model: {
      value: _vm.remove_dialog,
      callback: function ($$v) {
        _vm.remove_dialog = $$v;
      },
      expression: "remove_dialog"
    }
  }, [_vm.selectedSubjectForTrash ? _c('v-card', [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "red"
    }
  }, [_vm._v("mdi-close-circle")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('p', [_vm._v("Do you want to trash subject "), _c('code', [_vm._v(_vm._s(_vm.selectedSubjectForTrash.name))]), _vm._v("? You will be able to restore it for 30 days. After that, this subject will be permanently removed.")])])], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.remove_dialog = false;
        _vm.selectedSubjectForTrash = null;
      }
    }
  }, [_vm._v("No")]), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.remove_dialog = false;
        _vm.trashSubject(_vm.selectedSubjectForTrash.id);
        _vm.selectedSubjectForTrash = null;
      }
    }
  }, [_vm._v("Yes")])], 1)], 1) : _vm._e()], 1), _c('v-dialog', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDialogSubjectHideMenu,
      expression: "clickOutsideDialogSubjectHideMenu"
    }],
    attrs: {
      "content-class": "confirm-dialog",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    model: {
      value: _vm.restore_dialog,
      callback: function ($$v) {
        _vm.restore_dialog = $$v;
      },
      expression: "restore_dialog"
    }
  }, [_vm.selectedSubjectForRestore ? _c('v-card', [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "green"
    }
  }, [_vm._v("mdi-undo-variant")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('p', [_vm._v("Do you want to restore subject "), _c('code', [_vm._v(_vm._s(_vm.selectedSubjectForRestore.name))]), _vm._v("?")])])], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.restore_dialog = false;
        _vm.selectedSubjectForRestore = null;
      }
    }
  }, [_vm._v("No")]), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.restore_dialog = false;
        _vm.restoreSubject(_vm.selectedSubjectForRestore.id);
        _vm.selectedSubjectForRestore = null;
      }
    }
  }, [_vm._v("Yes")])], 1)], 1) : _vm._e()], 1), _c('v-dialog', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDialogSubjectHideMenu,
      expression: "clickOutsideDialogSubjectHideMenu"
    }],
    attrs: {
      "content-class": "confirm-dialog",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    model: {
      value: _vm.remove_permanently_dialog,
      callback: function ($$v) {
        _vm.remove_permanently_dialog = $$v;
      },
      expression: "remove_permanently_dialog"
    }
  }, [_vm.selectedSubjectForPermanentDelete ? _c('v-card', [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "red"
    }
  }, [_vm._v("mdi-close-circle")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('p', [_vm._v("Do you want to "), _c('strong', [_vm._v("permanently")]), _vm._v(" remove subject "), _c('code', [_vm._v(_vm._s(_vm.selectedSubjectForPermanentDelete.name))]), _vm._v("?")])])], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.remove_permanently_dialog = false;
        _vm.selectedSubjectForPermanentDelete = null;
      }
    }
  }, [_vm._v("No")]), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.remove_permanently_dialog = false;
        _vm.permanentRemoveSubject(_vm.selectedSubjectForPermanentDelete.id);
        _vm.selectedSubjectForPermanentDelete = null;
      }
    }
  }, [_vm._v("Yes")])], 1)], 1) : _vm._e()], 1), _c('v-dialog', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDialogSubjectHideMenu,
      expression: "clickOutsideDialogSubjectHideMenu"
    }],
    attrs: {
      "content-class": "confirm-dialog",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown
    },
    model: {
      value: _vm.download_dialog,
      callback: function ($$v) {
        _vm.download_dialog = $$v;
      },
      expression: "download_dialog"
    }
  }, [_vm.selectedSubjectForDownload ? _c('v-card', [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "m-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "green"
    }
  }, [_vm._v("mdi-download")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10"
    }
  }, [_c('p', [_vm._v("Do you want to download all data associated to the subject "), _c('code', [_vm._v(_vm._s(_vm.selectedSubjectForDownload.name))]), _vm._v("? (This includes every session and trial associated to it, and can take several minutes).")])])], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.download_dialog = false;
        _vm.selectedSubjectForDownload = null;
      }
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": "",
      "disabled": _vm.downloading
    },
    on: {
      "click": function ($event) {
        _vm.download_dialog = false;
        _vm.downloadSubjectData(_vm.selectedSubjectForDownload.id);
        _vm.selectedSubjectForDownload = null;
      }
    }
  }, [_vm._v("Download")])], 1)], 1) : _vm._e()], 1), _c('DialogComponent', {
    ref: "dialogRef",
    on: {
      "subject-updated": _vm.submitEditSubject,
      "subject-added": _vm.loadValidSubjects
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }